import React from 'react'

const BannerOffer = () => {
  return (
    <div className='fx-reveal overflow-hidden'>
        <div className='flex justify-center w-full max-sm:flex-col'>
            <div className='bg-greenprimary p-4 w-8/12 max-sm:w-full text-center flex justify-center items-center'>
                <p className='text-pink font-bold text-sm'>Obtenez 10% de réduction si vous dépensez 1000 MAD ou plus !</p>
            </div>
            <div className='bg-pink p-4 w-4/12 max-sm:w-full text-center relative circle-rotate'>
                <p className='text-greenprimary font-bold text-sm z-10 relative'>économisent 10 %de réduction</p>
            </div>
        </div>
    </div>
  )
}

export default BannerOffer